import { type } from 'arktype';

/**
 * Base entity response interface with common fields
 */
export interface BaseEntity {
  id: string;
  createdAt: string; // ISO 8601
  updatedAt: string; // ISO 8601
}

/**
 * Base junction table query schema
 */
export const baseJunctionQuerySchema = type({
  'calendarId?': 'string',
});

/**
 * Base junction table create schema
 */
export const baseJunctionCreateSchema = type({
  calendarId: 'string',
});

/**
 * Base junction table response interface
 */
export interface BaseJunction extends BaseEntity {
  calendarId: string;
}
